// Токен живёт в sessionStorage, а не в localStorage: панель открывается для
// разбора, и переживать закрытие вкладки сессии незачем. Токен доступа
// короткоживущий, обновления здесь нет вовсе — просрочился, значит вход
// заново. Для панели, которую открывают на время разбора, этого достаточно.

const KEY = 'ortaq.web.accessToken';
// Выбранная организация — там же и на тот же срок. Выбор переживает
// перезагрузку вкладки, но не её закрытие: работа в чужой организации,
// открывшаяся сама собой через неделю, — худшая из ошибок такого выбора.
const ORGANIZATION_KEY = 'ortaq.web.organizationId';

export function readToken(): string | null {
  try {
    return sessionStorage.getItem(KEY);
  } catch {
    return null;
  }
}

export function writeToken(token: string | null): void {
  try {
    if (token === null) sessionStorage.removeItem(KEY);
    else sessionStorage.setItem(KEY, token);
  } catch {
    // Хранилище может быть закрыто политикой браузера — панель продолжает
    // работать в пределах открытой страницы.
  }
}

export function readOrganizationId(): string | null {
  try {
    return sessionStorage.getItem(ORGANIZATION_KEY);
  } catch {
    return null;
  }
}

export function writeOrganizationId(organizationId: string | null): void {
  try {
    if (organizationId === null) sessionStorage.removeItem(ORGANIZATION_KEY);
    else sessionStorage.setItem(ORGANIZATION_KEY, organizationId);
  } catch {
    // Та же причина, что и у токена выше.
  }
}
